import { render, staticRenderFns } from "./activity-form-number-preview.vue?vue&type=template&id=5e82e72e&scoped=true&"
import script from "./activity-form-number-preview.vue?vue&type=script&lang=js&"
export * from "./activity-form-number-preview.vue?vue&type=script&lang=js&"
import style0 from "./activity-form-number-preview.vue?vue&type=style&index=0&id=5e82e72e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e82e72e",
  null
  
)

component.options.__file = "activity-form-number-preview.vue"
export default component.exports